export default {
  addresses: [],
  address: {}
}



// WEBPACK FOOTER //
// ./src/components/address/store/state.js